import { render, staticRenderFns } from "./assuntos-interesse-component.vue?vue&type=template&id=ebed60ae&"
import script from "./assuntos-interesse-component.vue?vue&type=script&lang=ts&"
export * from "./assuntos-interesse-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebed60ae')) {
      api.createRecord('ebed60ae', component.options)
    } else {
      api.reload('ebed60ae', component.options)
    }
    module.hot.accept("./assuntos-interesse-component.vue?vue&type=template&id=ebed60ae&", function () {
      api.rerender('ebed60ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/assuntos-interesse-component.vue"
export default component.exports